import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import Title from "../title";
import { ComonIcons } from "../../contents/commonIcons";
import { FormGroup, Input, Label } from "reactstrap";
import SpinnerComponent from "../spinner/spinner";
import { setLoading } from "../../redux/actions/common/common-actions";
import { setSerchedBarcode } from "../../redux/actions/product/productAction";

export const BarcodeScannerPopup = ({ toggle, barcodeModal }) => {
  const dispatch = useDispatch();
  const [barcodeValue, setBarcodeValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [localRFID, setBarcode] = useState("");

  useEffect(() => {
    reset();
    createBarcodeReader();
    const keepBarcodeReaderFocussing = () => {
      const barcodeReader = document.getElementById("barcodeReader");
      console.log({ barcodeReader });
      const focus = barcodeReader?.focus();
      const select = barcodeReader?.select();
    };
    const addClick = document.addEventListener(
      "click",
      keepBarcodeReaderFocussing
    );
    return () => {
      //cleanup
      const removeClick = document.removeEventListener(
        "click",
        keepBarcodeReaderFocussing
      );
      deleteBarcodeReader();
      toggle();
    };
  }, []);

  const reset = () => {
    setBarcodeValue("");
    // dispatch(setMemberGymByMembershipCardId(""));
    deleteBarcodeReader();
  };
  const createBarcodeReader = () => {
    const RFIDReader = document.getElementById("barcodeReader");
    console.log({ RFIDReader });
    if (!RFIDReader) {
      const input = document.createElement("input");
      console.log({ input });
      // setBarcode("e.target.value");

      document.body.appendChild(input);
      input.type = "text";
      input.id = "barcodeReader";
      input.focus();
      input.select();
      input.display = "none";
      input.onchange = (e) => {
        setBarcodeValue(e.target.value);
        setBarcode(e.target.value);
        input.value = "";
      };
    } else {
      RFIDReader.focus();
      RFIDReader.select();
    }
  };
  const deleteBarcodeReader = () => {
    const RFIDReader = document.getElementById("barcodeReader");
    return RFIDReader?.remove();
  };
  useEffect(() => {
    if (localRFID) {
      deleteBarcodeReader();
      setIsLoading(true);

      const start = async () => {
        //fetch gym member by card number
        setLoading(true);
        /** here will save barcode to store and then close the modal */
        dispatch(setSerchedBarcode(localRFID));
        toggle();
      };
      setTimeout(() => {
        start();
      }, 1000);
    }
  }, [localRFID]);

  return (
    <Modal
      isOpen={barcodeModal}
      centered={true}
      size={"lg"}
      autoFocus={false}
      className="large-pop adding-popup"
      toggle={toggle}
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Scan Barcode " />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="member-info-wrapper info-wrapper blk-padding-y"
            style={{ height: "50vh", maxHeight: "50vh", textAlign: "center" }}
          >
            {!localRFID && (
              <div className="info-title">
                <Title title={"Ready For Scanning.."} />
              </div>
            )}
            <div className="info trainer-info h-100">
              {console.log({ localRFID })}
              <Row style={{ flexDirection: "row", justifyContent: "center" }}>
                <Col md={6}>
                  <FormGroup className="custom-inputs">
                    <Input
                      type="text"
                      name="BarcodeId"
                      id="BarcodeId"
                      maxLength={50}
                      disabled={true}
                      value={localRFID}
                      className={`form-control`}
                    />
                    <Label for="BarcodeId" className="">
                      Barcode Search
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              {isLoading && (
                <div className="d-flex flex-column align-items-center justify-content-center h-50">
                  <SpinnerComponent />
                  <h3>Please wait</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
